import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-30fe27f4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-dashboard-container"
};
const _hoisted_2 = {
  class: "avatar-wrapper"
};
const _hoisted_3 = {
  class: "font-h6 address"
};
const _hoisted_4 = {
  class: "tabs-wrapper"
};
const _hoisted_5 = {
  key: 0,
  class: "content-container"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "font-h5 empty"
}, "No items to display", -1));

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 1,
  class: "content-container"
};
const _hoisted_9 = {
  key: 0,
  class: "info-container"
};
const _hoisted_10 = {
  class: "info-wrapper"
};
const _hoisted_11 = {
  class: "font-subtitle1"
};
const _hoisted_12 = {
  class: "font-subtitle1 unit"
};
const _hoisted_13 = {
  class: "function-wrapper"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  class: "font-subtitle2"
};
const _hoisted_16 = ["disabled"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2"
}, "Withdraw Bonus", -1));

const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  class: "items-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_page_tabs = _resolveComponent("page-tabs");

  const _component_user_header = _resolveComponent("user-header");

  const _component_item_card = _resolveComponent("item-card");

  const _component_router_link = _resolveComponent("router-link");

  const _component_claim_modal = _resolveComponent("claim-modal");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_user_header, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      id: "user-dashboard-avatar",
      class: "avatar",
      style: _normalizeStyle(`background-image: url(${$data.avatar});`)
    }, null, 4), _createElementVNode("span", _hoisted_3, _toDisplayString($setup.briefAddress($data.address)), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_page_tabs, {
      tabs: $options.tabs,
      selectedId: $data.tabId,
      "onUpdate:selectedId": _cache[0] || (_cache[0] = $event => $data.tabId = $event)
    }, null, 8, ["tabs", "selectedId"])])]),
    _: 1
  }), $data.tabId === 0 && !$data.capybaraCollectedList.length && !$data.allianceCollectedList.length || $data.tabId === 1 && !$data.allianceCollectedList.length || $data.tabId === 2 && !$options.totalClaimableList.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [$data.tabId === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(`${$data.totalStaking} Staking`), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(`${!$data.isUnderGraceTime ? $data.totalBonus : 0} Bonus`), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: _normalizeClass(["button-wrapper", {
      disabled: $data.notStaking === 0 || $data.checking || $data.isStaking || $data.quasiStakeDisabled
    }]),
    disabled: $data.notStaking === 0 || $data.checking || $data.isStaking || $data.quasiStakeDisabled,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.registerQuasiStakingReward && $options.registerQuasiStakingReward(...args))
  }, [_createElementVNode("span", _hoisted_15, _toDisplayString($data.isStaking ? "Staking..." : "Stake All"), 1)], 10, _hoisted_14), _createElementVNode("div", {
    class: _normalizeClass(["button-wrapper row", {
      disabled: $data.totalBonus === 0 || $data.isUnderGraceTime || $data.checking || $data.quasiStakeDisabled
    }]),
    disabled: $data.totalBonus === 0 || $data.isUnderGraceTime || $data.checking || $data.quasiStakeDisabled,
    onClick: _cache[2] || (_cache[2] = (...args) => $options.getQuasiStakingReward && $options.getQuasiStakingReward(...args))
  }, _hoisted_18, 10, _hoisted_16)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [$data.tabId === 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($options.totalCollectedList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item-wrapper",
      key: index
    }, [_createVNode(_component_router_link, {
      custom: "",
      to: {
        name: 'CollectionDetail',
        params: {
          id: item.tokenId || item.tokenID,
          chain: item.symbol === 'CAPY' ? 'bsc' : 'eth',
          collection: item.symbol === 'CAPY' ? 'capybara' : item.label
        }
      }
    }, {
      default: _withCtx(({
        navigate
      }) => [_createVNode(_component_item_card, {
        product: item,
        onClick: navigate
      }, null, 8, ["product", "onClick"])]),
      _: 2
    }, 1032, ["to"])]);
  }), 128)) : _createCommentVNode("", true), $data.tabId === 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.allianceCollectedList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item-wrapper",
      key: index
    }, [_createVNode(_component_router_link, {
      custom: "",
      to: {
        name: 'CollectionDetail',
        params: {
          id: item.tokenId || item.tokenID,
          chain: 'eth',
          collection: item.label
        }
      }
    }, {
      default: _withCtx(({
        navigate
      }) => [_createVNode(_component_item_card, {
        product: item,
        onClick: navigate,
        quasiStaking: ""
      }, null, 8, ["product", "onClick"])]),
      _: 2
    }, 1032, ["to"])]);
  }), 128)) : _createCommentVNode("", true), $data.tabId === 2 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 2
  }, _renderList($options.totalClaimableList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item-wrapper",
      key: index
    }, [_createVNode(_component_item_card, {
      product: item,
      onClick: _ctx.navigate,
      onClaim: $options.checkAndToggle,
      isClaim: ""
    }, null, 8, ["product", "onClick", "onClaim"])]);
  }), 128)) : _createCommentVNode("", true)])])), $data.isClaimBoxDisplay ? (_openBlock(), _createBlock(_component_claim_modal, {
    key: 2,
    detail: $data.modalDetail,
    auto: "",
    noPadding: "",
    isApproved: $data.modalDetail.tokenAddress === '0x6B8221954A96474a87F6C245B5c7F5Da9B270Ea9' ? true : $data.isNowSelectedBeApproved,
    isPending: $data.txStatus === null,
    isExcuting: $data.isExcuting,
    network: _ctx.chainId,
    onClaim: $options.claim,
    onAllowance: $options.getAllowance,
    onApprove: $options.approve
  }, null, 8, ["detail", "isApproved", "isPending", "isExcuting", "network", "onClaim", "onAllowance", "onApprove"])) : _createCommentVNode("", true)]);
}